export default "* Hvordan kunne jægerstenalderfolket lave både?\n* Hvilke materialer var bådene lavet af\n* Hvilke redskaber havde de?";